module.exports = __webpack_public_path__ + "static/media/international-competition-2.2.cfee1ed0.jpg";